import {
  type SiteResponse,
  SiteType,
  v1SitesList,
  type V1SitesListParams,
} from '@on3/api';
import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import { proxyApi } from '@on3/ui-lib/index';
import withAuthentication from '@on3/ui-lib/src/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/src/hocs/withValidUrl';
import { getFulfilledValue } from '@on3/ui-lib/utils/api';
import { type AxiosError } from 'axios';
import { PageWrapper } from 'components/Layouts/PageWrapper';
import { RightSidebarLayout } from 'components/Layouts/RightSidebarLayout';
import { StandardSidebar } from 'components/Layouts/StandardSidebar';
import { Teams } from 'components/Teams/Teams';
import type { GetServerSideProps } from 'next';

interface TeamListProps extends IGenericPageProps {
  fanSites: SiteResponse[] | null;
}

const TeamPage = (props: TeamListProps) => {
  const title = 'Explore Team Fan Sites - College Sports Coverage | On3.com';
  const description =
    'Discover your favorite college sports teams on On3.com. Engage with exclusive fan sites, get the latest news, insights, and community discussions for dedicated sports enthusiasts.';

  return (
    <PageWrapper {...props} description={description} title={title}>
      <RightSidebarLayout>
        <Teams fanSites={props.fanSites} />
        <StandardSidebar />
      </RightSidebarLayout>
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  try {
    const fanSiteParams: V1SitesListParams = {
      type: SiteType.Team,
    };

    const [fanSites] = await Promise.allSettled([
      v1SitesList(proxyApi, fanSiteParams),
    ]);

    return {
      props: {
        pageType: 'category',
        siteData,
        userData: userData || {},
        fanSites: getFulfilledValue(fanSites),
      },
    };
  } catch (error) {
    const err: AxiosError<unknown> = error as AxiosError<unknown>;

    console.log(err.message);

    return {
      props: {
        pageType: 'category',
        siteData,
        userData: userData || {},
        fanSites: [],
      },
    };
  }
};

export default withValidUrl(TeamPage);
